export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.86cf2942.svg";